import { api } from '../../../../lib/api'

export const ADD_MERCHANT_REQUEST = 'ADD_MERCHANT_REQUEST'
export const ADD_MERCHANT_SUCCESS = 'ADD_MERCHANT_SUCCESS'
export const ADD_MERCHANT_FAILED = 'ADD_MERCHANT_FAILED'

export const addMerchant = function (data, onComplete) {
  return function (dispatch) {
    dispatch({
      type: ADD_MERCHANT_REQUEST
    })
    api.addMerchant(data).then(addMerchantResponse => {
      dispatch({
        type: ADD_MERCHANT_SUCCESS,
        payload: addMerchantResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: ADD_MERCHANT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/merchant/add-merchant.js